module.exports = __webpack_public_path__ + "img/DESARROLLO.1e396fd6.jpeg";